// extracted by mini-css-extract-plugin
export default {"error":"src-components-template-panel-panel-module__error--Z12Ov"};